module.exports = __webpack_public_path__ + "static/media/appstore-icon.6cc2470a.svg";